import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { cloneDeep } from 'lodash'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import { updatePrepayment } from '../../models/PaymentDictionary'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'

function* savePayments(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdatePrepayments)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updatePrepayment),
      ),
    ])

    const id_calendar = yield Effects.select(getCalendarId)

    const services: any = yield Effects.call(
      service,
      cloneDeep(action.values),
      id_calendar,
    )

    yield Effects.put({
      services,
      type: PaymentDictionaryActions.AcceptedPrepayment,
    })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(PaymentDictionaryActions.SavePrepayment, savePayments)
}
